(() => {
  const normalizeQuantity = (rawValue, rawMinimum, rawMaximum, rawIncrement) => {
    const value = Number(rawValue);
    const minimum = Math.max(1, Number(rawMinimum) || 1);
    const increment = Math.max(1, Number(rawIncrement) || 1);
    const maximum = Number(rawMaximum);
    if (!Number.isFinite(value) || value <= 0) return 0;
    if (Number.isFinite(maximum) && maximum < minimum) return 0;
    const candidate = minimum + Math.ceil(Math.max(0, value - minimum) / increment) * increment;
    if (!Number.isFinite(maximum)) return candidate;
    const greatestAllowed = minimum + Math.floor((maximum - minimum) / increment) * increment;
    return Math.min(candidate, greatestAllowed);
  };
  if (typeof globalThis.__B2B_REORDER_TEST_HOOK__ === 'function') globalThis.__B2B_REORDER_TEST_HOOK__({ normalizeQuantity });
  if (typeof document === 'undefined') return;

  document.querySelectorAll('[data-b2br]').forEach(root => {
    if (root.dataset.bound) return;
    root.dataset.bound = 'true';
    const form = root.querySelector('[data-b2br-form]');
    if (!form || root.dataset.approved !== 'true') return;
    const editors = [...form.querySelectorAll('[data-order-editor]')];
    const details = form.querySelector('[data-details]');
    const status = form.querySelector('[data-b2br-status]');
    const error = form.querySelector('[data-b2br-error]');
    const success = root.querySelector('[data-b2br-success]');
    const submit = form.querySelector('button[type="submit"]');
    const submitText = submit?.querySelector('span') || submit;
    const initialSubmit = submitText?.textContent || '';
    const storageKey = `b2b-reorder-draft:${location.pathname}`;
    let idempotencyKey = crypto.randomUUID();
    let active;
    let savingTimer;

    const money = value => new Intl.NumberFormat(root.dataset.locale || 'de', { style: 'currency', currency: 'CHF' }).format(value / 100);
    const announce = message => { if (status) status.textContent = message || ''; };
    const showError = message => { if (error) { error.textContent = message; error.hidden = !message; error.focus?.(); } };
    const inputs = editor => [...editor.querySelectorAll('.qty-input')];
    const update = editor => {
      const total = inputs(editor).reduce((sum, input) => sum + Number(input.value || 0) * Number(input.closest('[data-line]')?.dataset.price || 0), 0);
      const out = editor.querySelector('[data-total]');
      if (out) out.textContent = money(total);
      inputs(editor).forEach(input => {
        const line = input.closest('[data-line]');
        if (line) line.hidden = input.value === '0' && line.dataset.userRemoved === 'true';
      });
      window.clearTimeout(savingTimer);
      savingTimer = window.setTimeout(save, 250);
    };
    const save = () => {
      if (!active) return;
      const draft = {
        expiresAt: Date.now() + 7 * 864e5,
        orderIndex: editors.indexOf(active),
        quantities: inputs(active).map(input => input.value),
        requestedDate: form.elements.requestedDate?.value || '',
        substitutionPolicy: form.elements.substitutionPolicy?.value || 'none'
      };
      sessionStorage.setItem(storageKey, JSON.stringify(draft));
    };
    const selectOrder = id => {
      active = editors.find(editor => editor.dataset.orderEditor === id);
      editors.forEach(editor => {
        const selected = editor === active;
        editor.hidden = !selected;
        inputs(editor).forEach(input => { input.disabled = !selected || input.dataset.available !== 'true'; });
      });
      details.hidden = !active;
      if (active) update(active);
      announce(root.dataset.msgSelected);
    };
    form.querySelectorAll('[data-order-select]').forEach(radio => radio.addEventListener('change', () => selectOrder(radio.value)));
    editors.forEach(editor => {
      editor.addEventListener('click', event => {
        const step = event.target.closest('[data-step]');
        const remove = event.target.closest('[data-remove]');
        if (step) {
          const input = step.parentElement.querySelector('.qty-input');
          const direction = Number(step.dataset.step);
          const current = Number(input.value || 0);
          const minimum = Number(input.dataset.minimum);
          const increment = Number(input.dataset.increment);
          const requested = direction > 0
            ? (current === 0 ? minimum : current + increment)
            : (current <= minimum ? 0 : current - increment);
          input.value = String(normalizeQuantity(requested, minimum, input.max, increment));
          input.dispatchEvent(new Event('input', { bubbles: true }));
        } else if (remove) {
          const line = remove.closest('[data-line]');
          line.dataset.userRemoved = 'true';
          line.querySelector('.qty-input').value = '0';
          update(editor);
        } else if (event.target.closest('[data-reset]')) {
          editor.querySelectorAll('[data-line]').forEach(line => {
            line.hidden = false; delete line.dataset.userRemoved;
            const input = line.querySelector('.qty-input');
            input.value = input.dataset.available === 'true' ? line.dataset.original : '0';
          });
          update(editor);
        } else if (event.target.closest('[data-remove-unavailable]')) {
          editor.querySelectorAll('.b2br-line--unavailable').forEach(line => { line.hidden = true; });
          announce(root.dataset.msgSelected);
        }
      });
      editor.addEventListener('input', event => {
        if (event.target.matches('.qty-input')) {
          event.target.value = String(normalizeQuantity(
            event.target.value,
            event.target.dataset.minimum,
            event.target.max,
            event.target.dataset.increment
          ));
          update(editor);
        }
      });
    });
    form.addEventListener('input', save);
    form.querySelector('[data-discard]')?.addEventListener('click', () => {
      sessionStorage.removeItem(storageKey);
      form.reset(); active = undefined; editors.forEach(e => e.hidden = true); details.hidden = true;
      announce(root.dataset.msgDiscarded);
    });
    root.querySelector('[data-restart]')?.addEventListener('click', () => {
      success.hidden = true; form.hidden = false; form.reset(); active = undefined;
      editors.forEach(e => e.hidden = true); details.hidden = true; idempotencyKey = crypto.randomUUID();
    });

    try {
      const draft = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (draft?.expiresAt > Date.now() && Number.isInteger(draft.orderIndex) && editors[draft.orderIndex]) {
        const restoredEditor = editors[draft.orderIndex];
        const restoredOrder = restoredEditor.dataset.orderEditor;
        const radio = [...form.querySelectorAll('[data-order-select]')].find(option => option.value === restoredOrder);
        radio.checked = true; selectOrder(restoredOrder);
        inputs(active).forEach((input, index) => {
          if (input.dataset.available === 'true') {
            input.value = String(normalizeQuantity(
              draft.quantities?.[index] || 0,
              input.dataset.minimum,
              input.max,
              input.dataset.increment
            ));
          }
        });
        form.elements.requestedDate.value = draft.requestedDate || '';
        form.elements.substitutionPolicy.value = draft.substitutionPolicy || 'none';
        update(active); announce(root.dataset.msgRestored);
      } else if (draft) sessionStorage.removeItem(storageKey);
    } catch { sessionStorage.removeItem(storageKey); }

    form.addEventListener('submit', async event => {
      event.preventDefault(); showError('');
      if (!form.checkValidity()) { form.reportValidity(); return; }
      const items = inputs(active).filter(input => input.dataset.available === 'true' && Number(input.value) > 0)
        .map(input => ({
          variantReference: input.dataset.variant,
          quantity: Number(input.value),
          expectedUnitPrice: (Number(input.closest('[data-line]')?.dataset.price || 0) / 100).toFixed(2),
          expectedCurrency: root.dataset.currency
        }));
      if (!items.length) { showError(root.dataset.msgEmpty); return; }
      const fd = new FormData(form);
      const payload = {
        program: root.dataset.program,
        shopifyOrderReference: active.dataset.orderEditor,
        items,
        substitutionPolicy: fd.get('substitutionPolicy'),
        requestedDate: fd.get('requestedDate'),
        notes: String(fd.get('notes') || '').trim() || undefined,
        consented: false,
        consentPurpose: 'b2b_reorder',
        consentVersion: root.dataset.consentVersion,
        locale: root.dataset.locale
      };
      submit.disabled = true; submitText.textContent = root.dataset.msgSending;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(root.dataset.proxyUrl, { method: 'POST', signal: controller.signal, headers: { 'Content-Type': 'application/json', 'Idempotency-Key': idempotencyKey }, body: JSON.stringify(payload) });
        const body = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(body.error || root.dataset.msgApi);
        if (!/^[0-9a-f-]{36}$/i.test(body.id || '') || body.status !== 'requested' || typeof body.capabilityToken !== 'string' || body.capabilityToken.length < 32 || !String(body.authorityNotice || '').includes('Shopify remains authoritative')) throw new Error(root.dataset.msgContract);
        sessionStorage.removeItem(storageKey); form.hidden = true; success.hidden = false; success.focus(); idempotencyKey = crypto.randomUUID();
      } catch (err) {
        showError(err.name === 'AbortError' ? root.dataset.msgTimeout : err.message || root.dataset.msgApi);
      } finally {
        clearTimeout(timeout); submit.disabled = false; submitText.textContent = initialSubmit;
      }
    });
  });
})();